//COMMANDS FOR YOUTUBE VIDEOS
function videoCommand(player, command) {
	var currentVideo = player.find('iframe').get(0)
	command = {
		event: 'command',
		func: command,
	}

	if (currentVideo != undefined) {
		currentVideo.contentWindow.postMessage(JSON.stringify(command), '*')
	}
}

$('.videoplayer .videoplayer__play').click(function (e) {
	var videoPlayer = $(this).parent()
	var videoType = videoPlayer.attr('data-videotype')
	var videoID = videoPlayer.attr('data-video')

	if (!$('iframe', videoPlayer).length) {
		switch (videoType) {
			case 'youtube':
				var iframe =
					'<iframe src="//www.youtube-nocookie.com/embed/' +
					videoID +
					'?rel=0&amp;modestbranding=1&amp;showinfo=0&amp;enablejsapi=1&amp;mute=1" frameborder="0" allowfullscreen=""></iframe>'
				$('.videoplayer__inner', videoPlayer).append(iframe)
				videoPlayer.addClass('videoplayer--is-loading')
				$('iframe', videoPlayer).on('load', function () {
					setTimeout(function () {
						videoPlayer.addClass('videoplayer--is-playing')
						videoPlayer.removeClass('videoplayer--is-loading')
						videoCommand(videoPlayer, 'playVideo')
					}, 500)
				})
				break

				/*case 'vimeo':
              var iframe = '<iframe src="https://player.vimeo.com/video/' + videoID + '?color=FFED00" frameborder="0" allowfullscreen></iframe>';

              $('.videoplayer__inner', videoPlayer).append(iframe);
              videoPlayer.addClass('videoplayer--is-loading');
              $('iframe', videoPlayer).on('load', function () {
                var vimeoOptions = {
                    muted: true,
                    autoplay: true
                };
                var vimeoPlayer = new Vimeo($('iframe', videoPlayer), vimeoOptions);
                vimeoPlayer.setVolume(0);
                setTimeout(function(){
                    vimeoPlayer.play();
                    videoPlayer.addClass('videoplayer--is-playing');
                    videoPlayer.removeClass('videoplayer--is-loading');
                },500);

            })*/
				break
			default:
		}
	}
})

if ($('.slider--video').length) {
	$('.slider--video').on('change.flickity', function () {
		$('.slider--video .videoplayer--is-playing').each(function (index, el) {
			var videoPlayer = $(this)
			var videoType = videoPlayer.attr('data-videotype')

			switch (videoType) {
				case 'youtube':
					videoCommand(videoPlayer, 'pauseVideo')
					break

				case 'vimeo':
					new Vimeo($('iframe', videoPlayer)).pause()
					break
				default:
			}
		})
	})
}
